import React from "react";

export default function TaskListEmptyStateCard({
  icon,
  title = null,
  message,
  grouped = false,
  className = "",
  iconClassName = "muted-text",
  titleClassName = "muted-text font-semibold",
  textClassName = "muted-text",
}) {
  const rootClassName = [
    "flex items-center gap-3 px-3 py-4 text-left",
    grouped ? "rounded-2xl bg-card shadow" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={rootClassName}>
      <span
        className={[
          "material-symbols-outlined text-[28px] leading-none shrink-0",
          iconClassName,
        ]
          .filter(Boolean)
          .join(" ")}
        aria-hidden="true"
      >
        {icon}
      </span>
      <div className="min-w-0 flex flex-col gap-1">
        {title ? <p className={titleClassName}>{title}</p> : null}
        {message ? <p className={textClassName}>{message}</p> : null}
      </div>
    </div>
  );
}
